import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, Subject } from 'rxjs';
import { IApplicationsService, ResponseData, Application } from './applications.interfaces';
import { IEnvironmentService, Value } from '../environment/environment.interface';
import { IApplication } from '@platform500services/p500-ui-kit';
import { IConfigurationService } from '../configuration/configuration-service.interface';
import { map } from 'rxjs/operators';

function getShortType(str: string): string {
  const shortType = str.split('-');
  return shortType[0][0] + shortType[1][0];
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationService implements IApplicationsService {
  private url: Value;
  private data = new Subject<Application[]>();

  constructor(
    private http: HttpClient,
    @Inject('IEnvironmentService') private envService: IEnvironmentService,
    @Inject('IConfigurationService') public configurationService: IConfigurationService
  ) {
    this.url = this.envService.getVar('services.api') as string;
    forkJoin({
      currentAppData: this.http.get<Application>(this.url + '/application'),
      allAppData: this.http.get<ResponseData>(this.url + '/applications'),
    }).subscribe((data) => {
      const currentCRMIdx = data.allAppData.data.findIndex((crm) => crm.id === data.currentAppData.data.id);
      data.allAppData.data.splice(currentCRMIdx, 1);
      this.data.next([data.currentAppData.data as any, ...data.allAppData.data]);
      this.data.complete();
    });
  }

  getData(): Observable<IApplication[]> {
    const mapApplication = (app: any): IApplication => {
      if (app.type === 'tracking-software') {
        app.type = 'partner-platform';
      }
      return {
        ...app,
        type: app.type,
        shortType: getShortType(app.type),
      };
    };
    return this.data.asObservable().pipe(map((applications) => applications.map(mapApplication)));
  }
}
